import { IOfflineSchedule } from '../../data/api/models';

export const QUOTE_JOURNEY_OFFLINE_TYPE = 'quote-journey';

const PORTAL_PATHS = ['/auth', '/account', '/password'];

export function isPortalPath(pathname: string): boolean {
  return PORTAL_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

export function isQuoteJourneyOffline(schedule?: IOfflineSchedule): boolean {
  return !! schedule && QUOTE_JOURNEY_OFFLINE_TYPE === schedule.type;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/branding/offline.ts